// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".w-150 {\n  width: 150px;\n}\n.w-60 {\n  width: 60px;\n}", ""]);
// Exports
module.exports = exports;
